"use client";

import { useCurrentEditor } from "@tiptap/react";

import { HeadingDropdownMenu } from "@/components/tiptap-ui/heading-dropdown-menu/heading-dropdown-menu";
import InsertDropdownMenu from "@/components/tiptap-ui/insert-dropdown-menu/insert-dropdown-menu";
import { ListDropdownMenu } from "@/components/tiptap-ui/list-dropdown-menu/list-dropdown-menu";
import { MarkButton } from "@/components/tiptap-ui/mark-button/mark-button";
import { cn } from "@/lib/utils";
import { Separator } from "../tiptap-ui/separator/separator";
import UndoRedoButton from "../tiptap-ui/undo-redo-button/undo-redo-button";
import { Row } from "../ui/flex";

export const BasicToolbar = ({ className }: { className?: string }) => {
  const { editor } = useCurrentEditor();

  if (!editor) {
    return null;
  }

  return (
    <Row
      className={cn("grow-0 gap-2 py-2", className)}
      align="center"
      justify="space-between"
    >
      <div className="flex items-center gap-0.5">
        <UndoRedoButton action="undo" />
        <UndoRedoButton action="redo" />

        <Separator />

        {/* Basic formatting */}
        <MarkButton type="bold" />
        <MarkButton type="italic" />
        <MarkButton type="strike" />

        <Separator />

        {/* Lists */}
        <HeadingDropdownMenu levels={[1, 2, 3]} />
        <ListDropdownMenu types={["bulletList", "orderedList"]} />

        <Separator />

        <InsertDropdownMenu />
      </div>
    </Row>
  );
};
